<template>
  <ChartLayout :title="title" palette="tints" units="%">
    <DataGetter
      :url="apiRoute"
      :params="{
        allYears: true,
        countryISO,
        indicator,
        category: 'By technology',
      }"
      v-slot="{ data }"
    >
      <DataSlicer
        :data="data"
        x-axis-dimension="year"
        y-axis-dimension="techSector"
        value-dimension="value"
        v-slot="{ slicedData }"
      >
        <Chart
          :options="{
            ...chartOptions,
            series: [...slicedData]
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map((series) => ({ ...series, colorIndex: techSectorOrder.indexOf(series.name) % 12 })),
          }"
        />
      </DataSlicer>
    </DataGetter>
  </ChartLayout>
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartOptions, {
  ChartLayout,
} from "@international-energy-agency/vue-ui/highcharts";
import { DataGetter, DataSlicer } from "@international-energy-agency/vue-ui";
import techSectorOrder from '../data/techSectorOrder';
export default {
  props: {
    title: {
      type: String,
      required: false,
    },
    apiRoute: {
      type: String,
      default: "https://api.iea.org",
    },
    indicator: {
      type: String,
      default: "Number of Start-ups",
    },
    countryISO: {
      type: String,
      required: true,
    },
  },
  components: {
    Chart,
    ChartLayout,
    DataGetter,
    DataSlicer,
  },
  data() {
    return {
        techSectorOrder,
      chartOptions: ChartOptions.buildOptions(
        {
          xAxis: {
            min: 2000,
          },
          yAxis: {
            max: 100.5,
            endOnTick: false,
            reversedStacks: true,
            plotLines: [
              {
                value: 0,
                className: "highcharts-zero-axis",
              },
              {
                value: 100,
                className: "highcharts-zero-axis",
              },
            ],
          },
          tooltip: {
            valueDecimals: 0,
            pointFormat:
              "<span class='highcharts-color-{point.series.colorIndex}'>●</span> {point.series.name} <b>{point.percentage:.1f}%</b><br/>",
            shared: true,
          },
          plotOptions: {
            column: {
              groupPadding: 0,
              stacking: "percent",
              connectNulls: true,
              label: {
                enabled: true,
              },
            },
          },
        },
        "column"
      ),
    };
  },
};
</script>
